import { ProductDetailActions as ProductDetail } from "./ProductDetail";
import { combineReducers, createStore, Store } from "lib/store/v3";
import { createStoreLogger } from "lib/store/v3/createStoreLogger";

const reducer = combineReducers({ ProductDetail }, createStoreLogger("ProductDetail"));

export type ProductDetailStore = Store<typeof reducer>;

export const { useSelector: useProductDetailSelector, ...ProductDetailStore } = createStore(reducer);
